(function (root) {
  const reviewOverrides = {'loox:uIL94I7KxA':{market:'au',cities:['melbourne'],regions:[]}};
  const clean = value => String(value || '').replace(/\s+/g, ' ').trim();
  const phrase = (text, value) => text.toLowerCase().includes(value);
  const imageKey = value => {
    const file = String(value || '').split('?')[0].split('/').pop();
    const parts = file.split('__');
    return parts.length > 2 ? parts[parts.length - 2] : file.replace(/_(mid|small|large|thumb)\.[^.]+$/, '');
  };
  function classify(product, body, template, rules) {
    const title = clean(product).toLowerCase();
    if (template === 'american-2' || /\b(nfl|nba|nhl|ncaa|mlb|america|american)\b/.test(title) || title.includes('miami dolphins') || title.includes('usc trojans')) return {market:'us',cities:[],regions:[]};
    if (title.includes('st george illawarra')) return {market:'au',cities:['sydney','wollongong'],regions:[]};
    if (title.includes('xxxx') || title.includes('queensland maroons')) return {market:'au',cities:[],regions:['qld']};
    if (title.includes('nsw blues') || title.includes('new south wales')) return {market:'au',cities:[],regions:['nsw']};
    let cities = Object.entries(rules.cityTerms).filter(([, terms]) => terms.some(term => phrase(title,term))).map(([city]) => city);
    if (!cities.length) cities = Object.keys(rules.cityTerms).filter(city => new RegExp('\\b' + city.replaceAll('-', ' ') + '\\b','i').test(body || ''));
    if (cities.length) return {market:cities.some(city => ['auckland','ibiza','dubai'].includes(city))?'other':'au',cities,regions:[]};
    if (template === 'australian' || /\b(holden|hsv|australia|australian|footy)\b/.test(title)) return {market:'au',cities:[],regions:[]};
    return {market:'general',cities:[],regions:[]};
  }
  function deduplicate(reviews) {
    const ids = new Set(), pictures = new Set(), texts = new Set();
    return reviews.filter(review => {
      if (!review || !review.id || ids.has(review.id) || review.rating < 1 || review.rating > 5) return false;
      ids.add(review.id);
      const images = (review.images || []).map(imageKey);
      const text = clean(review.name).toLowerCase()+'|'+clean(review.body).toLowerCase()+'|'+review.handle;
      if (images.some(image => pictures.has(image)) || (review.body && texts.has(text))) return false;
      images.forEach(image => pictures.add(image));
      if (review.body) texts.add(text);
      return true;
    });
  }
  function normalizeLoox(review, data) {
    const product = review.product || {}, known = data.products[product.handle] || Object.values(data.products).find(p => p.name === product.name);
    const title = known?.name || product.name || 'Custom Neon Sign';
    return {id:'loox:'+review.id,source:'loox',sourceId:review.id,name:clean(review.author)||'Customer',body:review.review||'',title:'',rating:Number(review.rating),date:review.date||'',verified:review.verified===true,images:(review.media||[]).filter(m=>m.t==='photo').map(m=>m.src.startsWith('//')?'https:'+m.src:m.src),product:title,handle:known?.handle||product.handle||'',...classify(title,review.review,known?.template,data.rules)};
  }
  function prepare(data, liveReviews) {
    const existing = new Set(data.reviews.map(review=>review.id));
    const recent = (liveReviews || []).filter(review=>review.id && !existing.has('loox:'+review.id)).map(review=>normalizeLoox(review,data));
    return deduplicate([...recent,...data.reviews]);
  }
  function priority(review, audience, city, rules) {
    const general = review.market === 'general' && !review.cities.length && !review.regions.length;
    if (audience === 'city') {
      if (!city) return general ? 2 : Infinity;
      if (review.cities.includes(city)) return 0;
      if (!review.cities.length && review.regions.some(region=>(rules.regionCities[region]||[]).includes(city))) return 1;
      return general ? 2 : Infinity;
    }
    if (audience === 'au') return review.market === 'au' || general ? 0 : Infinity;
    if (audience === 'us') return review.market === 'us' ? review.source === 'judgeme' ? 0 : 1 : general ? 2 : Infinity;
    if (audience === 'general') return general ? 0 : Infinity;
    return 0;
  }
  function select(reviews, audience, city, rules) {
    return reviews.map((original,index)=>{
      const review = reviewOverrides[original.id] ? {...original,...reviewOverrides[original.id]} : original;
      return {review,index,rank:priority(review,audience,city,rules)};
    })
      .filter(item=>Number.isFinite(item.rank))
      .sort((a,b)=>Number(Boolean(b.review.images.length))-Number(Boolean(a.review.images.length)) || a.rank-b.rank || a.index-b.index)
      .map(item=>item.review);
  }
  root.NeonReviewTools = {classify,deduplicate,normalizeLoox,prepare,priority,select};
  if (typeof module !== 'undefined' && module.exports) module.exports = root.NeonReviewTools;
})(typeof globalThis !== 'undefined' ? globalThis : window);
